import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import { AdminMap, SelectPosition, NotificationsList } from './components';
import { Button } from '../../../Shared';
import { getLoadingUpdateTrafficStatus } from '../../../../state/selectors/adminUser.selector';
import {
  StyledWrapper,
  StyledTextContent,
  StyledHeaderMap,
  useStylesGrid,
  StyledTextField,
  StyledSelect,
  StyledSelectReason,
  StyledSelectWeather,
  StyledWrapFormStatus,
  StyledFormStatus,
  StyledNotificationButton
} from './HomeAdmin.styled';

import { updateTrafficStatus, updateTrafficStatusSpeech } from '../../../../features/adminUserSlice';

import { MainTitle, TextField as MyTextField } from '../../../Shared';

import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog
} from '@material-ui/core';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AudioReactRecorder, { RecordState } from 'audio-react-recorder';
import { ObjectID } from 'bson';
import { adminUserService } from '../../../../services';
import axios from "axios";

const REACT_APP_DOLBY_API_KEY = process.env.REACT_APP_DOLBY_API_KEY;
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const HomeAdmin = (props) => {
  const { t } = useTranslation();
  const classesGrid = useStylesGrid();
  const dispatch = useDispatch();

  const loading = useSelector(getLoadingUpdateTrafficStatus);

  const reasonOfStatus = [
    {
      id: 1,
      code: 'TJ',
      content: t('trafficJam'),
    },
    {
      id: 2,
      code: 'FL',
      content: t('flooding'),
    },
    {
      id: 3,
      code: 'OB',
      content: t('obstacle'),
    },
    {
      id: 4,
      code: 'AC',
      content: t('accident'),
    },
    {
      id: 5,
      code: 'PO',
      content: t('police'),
    },
    {
      id: 6,
      code: 'FR',
      content: t('forbiddenRoad'),
    },
  ];

  const weatherOfStatus = [
    {
      id: 0,
      code: 'blankWeather',
      content: t('blankWeather'),
    },
    {
      id: 1,
      code: 'clearSky',
      content: t('clearSky'),
    },
    {
      id: 2,
      code: 'scatteredClouds',
      content: t('scatteredClouds'),
    },
    {
      id: 3,
      code: 'brokenClouds',
      content: t('brokenClouds'),
    },
    {
      id: 4,
      code: 'lightRain',
      content: t('lightRain'),
    },
    {
      id: 5,
      code: 'heavyRain',
      content: t('heavyRain'),
    },
    {
      id: 6,
      code: 'mist',
      content: t('mist'),
    },
  ];
  //state for map
  const [positionChoose, setPositionChoose] = useState('rectangle');
  const [positionChooseSpeech, setPositionChooseSpeech] = useState('speech');
  const [mapDataPosition, setMapDataPosition] = useState([]);
  const [radius, setRadius] = useState(300);
  const [radiusError] = useState('');
  const [option, setOption] = useState(0);

  const [effectiveTime, setEffectiveTime] = useState(10);
  const [reason, setReason] = useState('TJ');
  const [weather, setWeather] = useState('blankWeather');
  const [velocity, setVelocity] = useState(-1);
  const [description, setDescription] = useState('');

  const [isDisplayTrafficStatus, setIsDisplayTrafficStatus] = useState(false);

  const [openNotificationDialog, setOpenNotificationDialog] = useState(false);
  const [notificationsList,setNotificationsList] = useState([]);

  const [value, setValue] = useState(0);
  const dolbyInputUrl = 'https://api.dolby.com/media/input';
  const dolbyEnhanceUrl = 'https://api.dolby.com/media/enhance';

  const initialState = {
    record: RecordState.STOP,
    link: '',
    complete: false,
    recordedBlob: null,
  };

  const [state, setState] = useState(initialState);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const disabledButton = mapDataPosition.length === 0 || velocity < 0;

  const handleChangeEffectiveTime = (event) => {
    setEffectiveTime(event.target.value);
  };

  const handleChangeReason = (event) => {
    setReason(event.target.value);
  };

  const handleChangeWeather = (event) => {
    setWeather(event.target.value);
  }

  const handleChangeVelocity = (event) => {
    setVelocity(event.target.value);
  };

  const handleChangeDescription = (event) => {
    setDescription(event.target.value);
  };

  const handleSubmitForm = () => {
    const dataToSend = {
      type: positionChoose,
      coordinates: mapDataPosition,
      velocity,
      active_time: effectiveTime * 60,
      description,
      causes: [reason],
      weather: weather,
      images: [],
    };

    if (positionChoose === 'circle') {
      dataToSend.radius = radius;
    }

    if (positionChoose === 'line') {
      dataToSend.option = option;
    }
    dispatch(updateTrafficStatus(dataToSend));
  };

  const handleSubmitSpeech = () => {
    if (!state.recordedBlob) return alert('Fail to send! No record file');
    let id = new ObjectID();
    let audioFile = new File([state.recordedBlob], id.toString() + ".wav");
    
    handleEnhanceAudio(audioFile, id);

    let formData = new FormData();
    formData.append('speech_record_id', id);
    formData.append('type', positionChooseSpeech);
    if (positionChooseSpeech === 'circle') formData.append('radius', radius);
    if (positionChooseSpeech === 'line') formData.append('option', option);
    formData.append('coordinates', JSON.stringify(mapDataPosition))
    formData.append('active_time', effectiveTime * 60); // in seconds
    formData.append('record', state.recordedBlob, 'record');

    console.log(...formData);
    dispatch(updateTrafficStatusSpeech(formData));
    // adminUserService.speechReport(formData);
  };

  const handleEnhanceAudio = async (audioFile, objectId) => {
    const input = `dlb://${objectId}`
    const output = `dlb://enhanced${objectId}`

    const serverUrl = await axios({
      method: 'POST',
      url: dolbyInputUrl,
      data: { url: input },
      headers: { 'x-api-key': REACT_APP_DOLBY_API_KEY }
    })
      .then(res => { return res.data.url })
      .catch(err => console.error(err))

    await axios({
      method: 'PUT',
      url: serverUrl,
      data: audioFile
    })
      .catch(err => console.error(err))

    await axios({
      method: 'POST',
      url: dolbyEnhanceUrl,
      data: { input: input, output: output },
      headers: { 'x-api-key': REACT_APP_DOLBY_API_KEY }
    })
  }
  const onStop = (recordedBlob) => {
    console.log("Stop:", recordedBlob);
    setState(prevState => ({
      ...prevState,
      link: recordedBlob.url,
      recordedBlob: recordedBlob.blob,
    }));
  };
  const onRecord = () => {
    if (state.record === RecordState.STOP) {
      setState(prevState => ({
        ...prevState,
        record: RecordState.START,
      }));
    } else {
      setState(prevState => ({
        ...prevState,
        record: RecordState.STOP,
        complete: true,
      }));
    }
  }
  const onRecorderClicked = () => {
    const recorder = document.getElementById('recorder');
    if (recorder.classList.contains('recording')) {
      onRecord();
      recorder.classList.remove('recording');
      recorder.classList.add('download');
      setTimeout(() => {
        recorder.classList.remove('download');
        recorder.classList.add('out');
      }, 1000);
    }
    else if (
      !recorder.classList.contains('recording') &&
      !recorder.classList.contains('download')
    ) {
      onRecord();
      recorder.classList.remove('out');
      recorder.classList.add('recording');
    }
  }

  const showNotifications = () => {
    adminUserService.getAllRegisterHealthFacilities().then((res) => {
        setNotificationsList(res);
    });
    setOpenNotificationDialog(true);
  };
  const closeNotificationDialog = () => {
    setOpenNotificationDialog(false);
  };

  return (
    <StyledWrapper>
      <div>
        <Grid container direction='row' justify='center'>
          <Grid item xs={12} style={{display:"flex"}}>
              <StyledNotificationButton onClick={showNotifications}/>
              <Dialog fullWidth='true' maxWidth='md' open={openNotificationDialog} onClose={closeNotificationDialog}>
                <DialogTitle>
                  {t('notification')}
                </DialogTitle>
                <DialogContent>
                  <NotificationsList list={notificationsList}/>
                </DialogContent>
                <DialogActions>
                  <Button onClick={closeNotificationDialog} color="primary">
                  {t('close')}
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          <Grid item xs={12}>
            <StyledHeaderMap>{t('mainTitleHomeAdmin')}</StyledHeaderMap>
          </Grid>
          <Grid item  lg={6} md={7} sm={12} xs={12} style={{ padding: 8 }}>
            {value === 0 ? 
            <AdminMap
              setMapDataPosition={setMapDataPosition}
              positionChoose={positionChoose}
              radius={
                !radiusError && positionChoose === 'circle' ? radius : null
              }
              setRadius={setRadius}
              setOption={setOption}
              isDisplayTrafficStatus={isDisplayTrafficStatus}
            /> :
            <AdminMap
              setMapDataPosition={setMapDataPosition}
              positionChoose={positionChooseSpeech}
              radius={
                !radiusError && positionChooseSpeech === 'circle' ? radius : null
              }
              setRadius={setRadius}
              setOption={setOption}
              isDisplayTrafficStatus={isDisplayTrafficStatus}
            />
            }
          </Grid>

          <Box sx={{ width: '40%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label={t('FormReport')} {...a11yProps(0)} />
                <Tab label={t('SpeechReport')} {...a11yProps(1)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <Grid item sm={12} xs={12} style={{ padding: 8}}>
                <Grid
                  container
                  direction='row'
                  // justify='center'
                  alignItems='center'
                >
                  <MainTitle fontSize={16}>{t('ChangeModeLabel')}</MainTitle>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={() => {
                      setIsDisplayTrafficStatus(!isDisplayTrafficStatus);
                    }}
                    style={{ marginLeft: 16 }}
                  >
                    {!isDisplayTrafficStatus
                      ? t('ViewTrafficStatusButtonAdmin')
                      : t('UpdateTrafficStatusButtonAdmin')}
                  </Button>
                </Grid>
                  <SelectPosition
                    positionChoose={positionChoose}
                    setPositionChoose={setPositionChoose}
                    isDisabled={isDisplayTrafficStatus}
                    isSpeech={false}
                  />

                <StyledWrapFormStatus>
                  <StyledFormStatus>
                    <MainTitle fontSize={16}>{t('subtitleStatus')}</MainTitle>
                    <Grid
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='center'
                      className={classesGrid.root}
                      spacing={1}
                    >
                      <Grid item xs={4}>
                        <StyledTextContent>
                          {t('currentVelocity')}
                        </StyledTextContent>
                      </Grid>
                      <Grid item>
                        <MyTextField
                          type='number'
                          id='standard-basic'
                          label={t('currentVelocity')}
                          onChange={handleChangeVelocity}
                        />
                      </Grid>
                      <Grid item>
                        <StyledTextContent>(km/h)</StyledTextContent>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='center'
                      className={classesGrid.root}
                    >
                      <Grid item xs={4}>
                        <StyledTextContent>{t('effectiveTime')}</StyledTextContent>
                      </Grid>
                      <Grid item>
                        <StyledSelect
                          value={effectiveTime}
                          onChange={handleChangeEffectiveTime}
                          displayEmpty
                        >
                          <MenuItem value={10}>{`10 ${t(
                            'unitEffectiveTime'
                          )}`}</MenuItem>
                          <MenuItem value={20}>{`20 ${t(
                            'unitEffectiveTime'
                          )}`}</MenuItem>
                          <MenuItem value={30}>{`30 ${t(
                            'unitEffectiveTime'
                          )}`}</MenuItem>
                          <MenuItem value={40}>{`40 ${t(
                            'unitEffectiveTime'
                          )}`}</MenuItem>
                          <MenuItem value={50}>{`50 ${t(
                            'unitEffectiveTime'
                          )}`}</MenuItem>
                        </StyledSelect>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='center'
                      className={classesGrid.root}
                    >
                      <Grid item xs={4}>
                        <StyledTextContent>{t('description')}</StyledTextContent>
                      </Grid>
                      <Grid item>
                        <StyledTextField
                          onChange={handleChangeDescription}
                          id='standard-basic'
                          label={t('description')}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='center'
                    >
                      <Grid item xs={4}>
                        <StyledTextContent>{t('reason')}</StyledTextContent>
                      </Grid>
                      <Grid item>
                        {/* <StyledTextField id="standard-basic" label={t('reasonLabel')} /> */}
                        <StyledSelectReason
                          value={reason}
                          onChange={handleChangeReason}
                        >
                          {reasonOfStatus.map((reason) => (
                            <MenuItem key={reason.id} value={reason.code}>
                              {reason.content}
                            </MenuItem>
                          ))}
                        </StyledSelectReason>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='center'
                    >
                      <Grid item xs={4}>
                        <StyledTextContent>{t('weather')}</StyledTextContent>
                      </Grid>
                      <Grid item>
                        {/* <StyledTextField id="standard-basic" label={t('reasonLabel')} /> */}
                        <StyledSelectWeather
                          value={weather}
                          onChange={handleChangeWeather}
                        >
                          {weatherOfStatus.map((weather) => (
                            <MenuItem key={weather.id} value={weather.code}>
                              {weather.content}
                            </MenuItem>
                          ))}
                        </StyledSelectWeather>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction='row'
                      justify='center'
                      alignItems='center'
                    >
                      <Grid item>
                        <Button
                          type='submit'
                          // fullWidth
                          variant='contained'
                          color='primary'
                          className={classesGrid.button}
                          onClick={handleSubmitForm}
                          disabled={
                            disabledButton || loading || isDisplayTrafficStatus
                          }
                          loading={loading}
                        >
                          {t('titleUpdateButton')}
                        </Button>
                      </Grid>
                    </Grid>
                  </StyledFormStatus>
                </StyledWrapFormStatus>
              </Grid>
            </TabPanel>
            <TabPanel value={value} index={1}>
            <Grid item sm={12} xs={12} style={{ padding: 8}}>
                <Grid
                  container
                  direction='row'
                  // justify='center'
                  alignItems='center'
                >
                  <MainTitle fontSize={16}>{t('ChangeModeLabel')}</MainTitle>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={() => {
                      setIsDisplayTrafficStatus(!isDisplayTrafficStatus);
                    }}
                    style={{ marginLeft: 16 }}
                  >
                    {!isDisplayTrafficStatus
                      ? t('ViewTrafficStatusButtonAdmin')
                      : t('UpdateTrafficStatusButtonAdmin')}
                  </Button>
                </Grid>
                  <SelectPosition
                    positionChoose={positionChooseSpeech}
                    setPositionChoose={setPositionChooseSpeech}
                    isDisabled={isDisplayTrafficStatus}
                    isSpeech={true}
                  />

                <StyledWrapFormStatus>
                  <StyledFormStatus>
                    <MainTitle fontSize={16}>{t('subtitleStatus')}</MainTitle>
                    <Grid
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='center'
                      className={classesGrid.root}
                    >
                      <Grid item xs={4}>
                        <StyledTextContent>{t('effectiveTime')}</StyledTextContent>
                      </Grid>
                      <Grid item>
                        <StyledSelect
                          value={effectiveTime}
                          onChange={handleChangeEffectiveTime}
                          displayEmpty
                        >
                          <MenuItem value={10}>{`10 ${t(
                            'unitEffectiveTime'
                          )}`}</MenuItem>
                          <MenuItem value={20}>{`20 ${t(
                            'unitEffectiveTime'
                          )}`}</MenuItem>
                          <MenuItem value={30}>{`30 ${t(
                            'unitEffectiveTime'
                          )}`}</MenuItem>
                          <MenuItem value={40}>{`40 ${t(
                            'unitEffectiveTime'
                          )}`}</MenuItem>
                          <MenuItem value={50}>{`50 ${t(
                            'unitEffectiveTime'
                          )}`}</MenuItem>
                        </StyledSelect>
                      </Grid>
                    </Grid>
                    <div id="recorder" onClick={onRecorderClicked} style={{margin: "2em auto 0em auto"}}>
                      <img
                        id="record"
                        src="https://bassets.github.io/record.svg"
                        alt="voice report"
                      />
                      <img
                        id="arrow"
                        src="https://bassets.github.io/arrow.svg"
                        alt="replay"
                      />
                    </div>
                    <AudioReactRecorder 
                      state={state.record} 
                      onStop={onStop} 
                      canvasWidth="0px" 
                      canvasHeight="0px"
                    />
                    {state.complete &&
                      <Grid item>
                        <audio className="play-back" controls src={state.link}></audio>
                      </Grid>
                    } 
                    <Grid
                      container
                      direction='row'
                      justify='center'
                      alignItems='center'
                    >
                      <Grid item>
                        <Button
                          type='submit'
                          // fullWidth
                          variant='contained'
                          color='primary'
                          className={classesGrid.button}
                          onClick={handleSubmitSpeech}
                          disabled={
                            state.recordedBlob == null
                          }
                          loading={loading}
                        >
                          {t('titleUpdateButton')}
                        </Button>
                      </Grid>
                    </Grid>
                  </StyledFormStatus>
                </StyledWrapFormStatus>
              </Grid>
            </TabPanel>
          </Box>
          
        </Grid>
      </div>
    </StyledWrapper>
  );
};

export default HomeAdmin;
